import { render, staticRenderFns } from "./M2MReferenceDatesForm.vue?vue&type=template&id=8d33055c&scoped=true"
import script from "./M2MReferenceDatesForm.vue?vue&type=script&lang=js"
export * from "./M2MReferenceDatesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d33055c",
  null
  
)

export default component.exports